import type { editor } from "monaco-editor";

export const CADPLM_THEME: editor.IStandaloneThemeData = {
  base: "vs-dark",
  inherit: true,
  rules: [
    { token: "comment", foreground: "555568", fontStyle: "italic" },
    { token: "keyword", foreground: "c792ea" },
    { token: "string", foreground: "c3e88d" },
    { token: "number", foreground: "f78c6c" },
    { token: "type", foreground: "ffcb6b" },
    { token: "identifier", foreground: "c8c8d8" },
    { token: "delimiter", foreground: "8888a0" },
  ],
  colors: {
    "editor.background": "#0c0c0f",
    "editor.foreground": "#c8c8d8",
    "editorLineNumber.foreground": "#2a2a36",
    "editorLineNumber.activeForeground": "#555568",
    "editor.lineHighlightBackground": "#111116",
    "editor.selectionBackground": "#2a509040",
    "editorCursor.foreground": "#58a6ff",
    "editorIndentGuide.background": "#1e1e28",
    "editorIndentGuide.activeBackground": "#2a2a36",
    "editor.lineHighlightBorder": "#00000000",
    "editorOverviewRuler.border": "#00000000",
    "scrollbarSlider.background": "#2a2a3540",
    "scrollbarSlider.hoverBackground": "#3a3a4860",
  },
};

export const THEME_NAME = "cadplm";
